// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rvBV","question":"styles_question__bFlli","description":"styles_description__3Jj1U"};